import { DefaultState, DropdownItem } from 'store/types';

export const ADD_BY_MANAGER_REQUEST = 'ADD_BY_MANAGER_REQUEST';
export const ADD_BY_MANAGER_SUCCESS = 'ADD_BY_MANAGER_SUCCESS';
export const ADD_BY_MANAGER_FAILURE = 'ADD_BY_MANAGER_FAILURE';

export interface AddNewGuest {
  id: string;
  guestType: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  gender: string;
}

export interface AddNewRoommate {
  id: string;
  firstName: string;
  lastName: string;
}

export interface AddByManagerParams {
  guest: AddNewGuest;
  roommates: Array<AddNewRoommate>;
  locationId: string;
  fromDate: string;
  toDate: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  storeNumber: string;
  corporateClientName: string;
  location: {
    longitude: number;
    latitude: number;
  };
  lodgingNotes?: string;
  lodgingTypes?: string[];
  talentAgentEmail?: string;
  startTimeOfJob?: string;
  lodgingCost?: string;
  datesScheduled?: string;
}

export interface AddNewRequest {
  guest: AddNewGuest;
  roommates: AddNewRoommate[];
  locationId: string;
  fromDate: Date | null;
  toDate: Date | null;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  location: string;
  lodgingNotes: string;
  lodgingTypes: DropdownItem[];
  storeNumber: string;
  corporateClientName: string;
  talentAgentEmail?: string;
  startTimeOfJob: Date | null;
  lodgingCost?: string;
  datesScheduled?: string;
}

export interface AddByManagerData { }

export type AddByManagerState = DefaultState & {
  contents?: AddByManagerData;
};

interface AddByManagerRequest {
  type: typeof ADD_BY_MANAGER_REQUEST;
}

interface AddByManagerSuccess {
  type: typeof ADD_BY_MANAGER_SUCCESS;
  contents: AddByManagerData;
}

interface AddByManagerFailure {
  type: typeof ADD_BY_MANAGER_FAILURE;
}

export type AddByManagerActionTypes =
  | AddByManagerRequest
  | AddByManagerSuccess
  | AddByManagerFailure;
